import { render } from "./AssignTeamLeader.vue?vue&type=template&id=a4aad32c&scoped=true"
import script from "./AssignTeamLeader.vue?vue&type=script&lang=js"
export * from "./AssignTeamLeader.vue?vue&type=script&lang=js"

import "./AssignTeamLeader.vue?vue&type=style&index=0&id=a4aad32c&scoped=true&lang=css"

import exportComponent from "/home/stagging/consillium/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4aad32c"]])

export default __exports__